import { action, observable } from 'mobx';
import stores from "cd-eft/models/Stores";

const { designStore, waterwayDesignStore } = stores.AppStore;

export class WaterwayTypeVM {

  constructor(props) {
      this.props = props;
  }

  @observable props;
  @observable waterwayName: string = waterwayDesignStore.waterwayName;
  @observable waterwayType: string = waterwayDesignStore.waterwayType;


  @action.bound async handleInputChange(event) {
    const { name, value } = event.target;
    if (name === "name") {
      this.waterwayName = value;
      waterwayDesignStore.waterwayName = value;
    } else if (name === "type") {
      this.waterwayType = value;
      waterwayDesignStore.waterwayType = value;
    }
  }

  @action.bound close() {
    waterwayDesignStore.waterwayName = '';
    waterwayDesignStore.waterwayType = '';
    this.props.handleOnClickCloseButtonOnSelectWaterwayTypePage();
  }

  @action.bound saveWaterway() {
    waterwayDesignStore.waterwayName = this.waterwayName;
    waterwayDesignStore.waterwayType = this.waterwayType;
    if(waterwayDesignStore.waterwayName){
      designStore.disableSaveButtonInputPage = false;
    }
    this.props.saveWaterwayOnSelectWaterwayTypePage();
  }
}